import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";
import { Logo } from "../ui/Logo";
import { LanguageSelector } from "../ui/LanguageSelector";

export function Footer() {
  const { t } = useI18n();
  const year = 2026;

  const cols = [
    {
      title: t("footer.product"),
      links: [
        { to: "/recursos", label: t("nav.features") },
        { to: "/seguranca", label: t("nav.security") },
        { to: "/integracoes", label: t("nav.integrations") },
        { to: "/docs", label: t("nav.docs") },
      ],
    },
    {
      title: t("footer.verticals"),
      links: [
        { to: "/exames", label: t("nav.exams") },
        { to: "/ctf", label: t("nav.ctf") },
      ],
    },
    {
      title: t("footer.company"),
      links: [
        { to: "/contato", label: t("nav.contact") },
        { to: "/blog", label: t("nav.blog") },
        { to: "/sobre", label: t("footer.about") },
      ],
    },
    {
      title: t("footer.legal"),
      links: [
        { to: "/privacidade", label: t("footer.privacy") },
        { to: "/termos", label: t("footer.terms") },
        { to: "/dpa", label: t("footer.dpa") },
      ],
    },
  ];

  return (
    <footer className="border-t border-border bg-secondary/30">
      <div className="container-x py-14">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm text-muted-foreground">{t("footer.tagline")}</p>
          </div>
          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground">{col.title}</h4>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-border pt-6 sm:flex-row">
          <p className="text-xs text-muted-foreground">
            © {year} SecProctoring — {t("footer.rights")} · {t("footer.madeBy")}
          </p>
          <LanguageSelector />
        </div>
      </div>
    </footer>
  );
}
